export default __webpack_public_path__ + "static/media/cityscape.e83aa4c6.svg";